//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import KirbyLink from './kirbylink.vue'
export default {
    name: "firstratecareer",
    props:{
      content: Object
    },
    components:{
      KirbyLink
    }
}
